export const CENTER_OF_CIRCLE = { x: 600, y: 390 };
export const INITIAL_TRIANGLE_RADIANS = [Math.PI / 2, Math.PI * 9 / 8, -Math.PI / 8];
export const CIRCLE_RADIUS = 200;
export const GUIDE_TEXT_COORD = { x: 100, y: 20 };
export const GUIDE_TEXT_TANGENT_COORD = { x: 100, y: 60 };
export const RANDOM_BUTTON_COORD = { x: 250, y: 800 };
export const SLIDERS_COORD = [{ x: 450, y: 800 }, { x: 810, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: 60, y: 420 }, { x: 60, y: 600 }]
export const INFO_SLIDER_COORD = { x: 1180, y: 200 };
export const BOUNDS_OF_COORD = { x: 1500, y: 800 };

export const PINK_ANGLE_COLORS = [0xFC99C4, 0xF94F6F];
export const BLUE_ANGLE_COLORS = [0x21D4FE, 0x0195B8];
export const PURPLE_COLORS = [0xb06efe, 0xb06efe];
export const CIRCLE_COLORS = [BLUE_ANGLE_COLORS[1], PINK_ANGLE_COLORS[1], 0x000000];
export const QUASIMODO_CON_COORD = { x: 120, y: 250 }
export const INFO_SLIDER_ASSETS_SLUG = "circle-theorem-3";

export const QUASIMODO = [
  "/circle-theorem-3/quasimodo/head.png",
  "/circle-theorem-3/quasimodo/foot.png",
  "/circle-theorem-3/quasimodo/corkscrew.png",
]
